export default "__VITE_ASSET__f86f6a0a__$_?url=__"